import { Divider, Paper, Typography } from "@mui/material";
import { t } from "i18next";
import GlobalTable from "../../../components/Tables/GlobalTable";

const headerData = ["service", "appointment", "earning"];

const tableRows = [
  "service_sub_name_worker",
  "totalAppointments",
  "service_sub_earning",
];

function ServiceAsAppointment({ allServices, isLoading }) {
  console.log(allServices,"JJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJ")
  return (
    <Paper
      sx={{
        borderRadius: "6px",
        height: 400,
        overflow: "auto",
      }}
    >
      <Typography variant="h5" fontWeight={600} p={2}>
        {t("servicesAndSales")}
      </Typography>
      <Divider />
      {allServices?.length > 0 ? (
        <GlobalTable
          minWidth={600}
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allServices}
          showPagination={false}
        />
      ) : (
        <Typography
          variant="h6"
          fontWeight={600}
          my={2}
          textAlign={"center"}
          p={2}
        >
          {t("noDataFound")}
        </Typography>
      )}
    </Paper>
  );
}

export default ServiceAsAppointment;
